import React, { useEffect, useState } from 'react';

import {
  useParams,
  useLocation,
  useNavigate,
  Link
} from 'react-router-dom';

import axios from 'axios';

import Header from '../../../../../../header/header';
import Navvbar from '../../../../../../header/Navvbar';

import './Editnextcase.css';

const Editnextcase = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [caseData, setCaseData] = useState(
    location.state?.caseData || null
  );

  const [loading, setLoading] = useState(
    !location.state?.caseData
  );

  const [saving, setSaving] = useState(false);

  const [descriptions, setDescriptions] = useState([]);

  const [showModal, setShowModal] = useState(false);

  const [newDescription, setNewDescription] = useState('');

  const [newAmount, setNewAmount] = useState('');

  const disabledLinks = [
    'Store',
    'Permission Groups',
    'Finances'
  ];

  const isDisabled = (name) =>
    disabledLinks.includes(name);

  useEffect(() => {
    if (!caseData && id) {
      fetchCaseData();
    } else if (
      caseData &&
      caseData.description &&
      descriptions.length === 0
    ) {
      parseDescriptions(caseData.description);
    }
  }, [id, caseData]);

  const parseDescriptions = (descriptionString) => {
    if (
      !descriptionString ||
      !descriptionString.trim()
    ) {
      setDescriptions([]);
      return;
    }

    const descParts = descriptionString
      .split(', ')
      .map((part) => {
        const match = part.match(
          /^(.+?)\s\(([^()]+)\)$/
        );

        if (match) {
          return {
            description: match[1].trim(),
            amount: match[2].trim()
          };
        }

        return {
          description: part.trim(),
          amount: ''
        };
      });

    setDescriptions(descParts);
  };

  const fetchCaseData = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `https://hms.backend.hiragroupcloud.com/api/remake-types/${id}`
      );

      if (response.data.success) {
        const apiData = response.data.data;

        setCaseData({
          id: apiData._id,
          name: apiData.reason || '',
          availableStage:
            apiData.availableStage ||
            'Case closed or invoiced',
          descriptionRequired:
            apiData.descriptionRequired ||
            false,
          procedure:
            apiData.preselectedProcedure ||
            'None',
          noteRequired:
            apiData.noteRequired || false,
          copyPracticeNote:
            apiData.copyPracticeNote ||
            false,
          copyPracticeFiles:
            apiData.copyPracticeFiles ||
            false,
          remakeNote:
            apiData.remakeNote || false,
          description:
            apiData.description || ''
        });

        if (apiData.description) {
          parseDescriptions(
            apiData.description
          );
        }
      }
    } catch (err) {
      console.error(
        'Error fetching case data:',
        err
      );

      setCaseData({
        id,
        name: '',
        availableStage:
          'Case closed or invoiced',
        descriptionRequired: false,
        procedure: 'None',
        noteRequired: false,
        copyPracticeNote: false,
        copyPracticeFiles: false,
        remakeNote: false,
        description: ''
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!caseData?.name?.trim()) {
      alert('Please enter a name.');
      return;
    }

    try {
      setSaving(true);

      const descriptionString =
        descriptions.length > 0
          ? descriptions
              .map(
                (d) =>
                  `${d.description} (${d.amount})`
              )
              .join(', ')
          : '';

      const updateData = {
        reason: caseData.name,
        description: descriptionString,
        availableStage:
          caseData.availableStage,
        descriptionRequired:
          caseData.descriptionRequired,
        preselectedProcedure:
          caseData.procedure,
        noteRequired:
          caseData.noteRequired,
        copyPracticeNote:
          caseData.copyPracticeNote,
        copyPracticeFiles:
          caseData.copyPracticeFiles,
        remakeNote:
          caseData.remakeNote
      };

      const response = await axios.put(
        `https://hms.backend.hiragroupcloud.com/api/remake-types/${id}`,
        updateData
      );

      if (response.data.success) {
        alert('Case updated successfully!');
        navigate('/caseSetting');
      }
    } catch (err) {
      console.error(
        'Error saving case data:',
        err
      );

      alert(
        err.response?.data?.message ||
          'Failed to save changes. Please try again.'
      );
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    navigate('/caseSetting');
  };

  const handleOpenModal = () => {
    setNewDescription('');
    setNewAmount('0');
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setNewDescription('');
    setNewAmount('0');
  };

  const handleAddDescription = () => {
    if (
      newDescription.trim() &&
      newAmount.trim()
    ) {
      setDescriptions((prev) => [
        ...prev,
        {
          description: newDescription.trim(),
          amount: newAmount.trim()
        }
      ]);

      handleCloseModal();
    } else {
      alert('Please fill in both fields.');
    }
  };

  const handleRemoveDescription = (index) => {
    setDescriptions((prev) =>
      prev.filter((_, i) => i !== index)
    );
  };

  if (loading) {
    return (
      <>
        <Header />
        <Navvbar />

        <div className="edit-next-case-loading">
          Loading...
        </div>
      </>
    );
  }

  return (
    <>
      <div className="edit-next-case-header">
        <Header />
        <Navvbar />
      </div>

      <div className="case-settings-wrapper">
        <div className="case-settings-container">

          {/* SIDEBAR */}
          <div className="sidebar-panel">

            <h4 className="sidebar-title">
              Settings
            </h4>

            <div className="links-group">

              <Link
                to="/lab-details"
                className="sidebar-link"
              >
                Lab Details
              </Link>

              <Link
                to={
                  isDisabled('Store')
                    ? '#'
                    : '/store'
                }
                onClick={
                  isDisabled('Store')
                    ? (e) => e.preventDefault()
                    : undefined
                }
                className={`sidebar-link ${
                  isDisabled('Store')
                    ? 'disabled-link'
                    : ''
                }`}
              >
                Store
              </Link>

              <Link
                to="/users"
                className="sidebar-link"
              >
                Users
              </Link>

              <Link
                to="#"
                onClick={(e) =>
                  e.preventDefault()
                }
                className="sidebar-link disabled-link"
              >
                Permission Groups
              </Link>

              <Link
                to="/accountTable"
                className="sidebar-link"
              >
                Accounts
              </Link>

              <Link
                to="/financeOwerview"
                className="sidebar-link"
              >
                Finances
              </Link>

              <Link
                to="/caseSetting"
                className="sidebar-link"
              >
                Case Settings
              </Link>

            </div>
          </div>

          {/* MAIN CONTENT */}
          <div className="main-content-panel">

            <h3 className="page-title">
              Edit Next-case Type
            </h3>

            {/* DETAILS */}
            <div>
              <h4 className="section-title">
                Details
              </h4>

              <div className="box-container">

                {/* Name */}
                <div className="form-row">

                  <label className="form-label">
                    Name{' '}
                    <span className="required-star">
                      *
                    </span>
                  </label>

                  <input
                    type="text"
                    value={caseData?.name || ''}
                    onChange={(e) =>
                      setCaseData((prev) => ({
                        ...prev,
                        name: e.target.value
                      }))
                    }
                    className="form-control-custom"
                  />

                </div>

                {/* Available Stage */}
                <div className="form-row">

                  <label className="form-label">
                    Available when the original case is in stage
                  </label>

                  <select
                    value={
                      caseData?.availableStage ||
                      'Case closed or invoiced'
                    }
                    onChange={(e) =>
                      setCaseData((prev) => ({
                        ...prev,
                        availableStage:
                          e.target.value
                      }))
                    }
                    className="form-control-custom"
                  >
                    <option value="Case closed or invoiced">
                      Case closed or invoiced
                    </option>

                    <option value="Case in progress">
                      Case in progress
                    </option>

                    <option value="Case completed">
                      Case completed
                    </option>
                  </select>

                </div>

                {/* Description Required */}
                <div className="form-row">

                  <label className="form-label">
                    Description selection required for Next case
                  </label>

                  <input
                    type="checkbox"
                    checked={
                      caseData?.descriptionRequired ||
                      false
                    }
                    onChange={(e) =>
                      setCaseData((prev) => ({
                        ...prev,
                        descriptionRequired:
                          e.target.checked
                      }))
                    }
                    className="small-checkbox"
                  />

                </div>

                {/* Procedure */}
                <div className="form-row">

                  <label className="form-label">
                    Preselect Procedure on Next case
                  </label>

                  <select
                    value={
                      caseData?.procedure ||
                      'None'
                    }
                    onChange={(e) =>
                      setCaseData((prev) => ({
                        ...prev,
                        procedure:
                          e.target.value
                      }))
                    }
                    className="form-control-custom"
                  >

                    <option value="None">
                      None
                    </option>

                    <option value="Same">
                      Same
                    </option>

                    <option value="Different">
                      Different
                    </option>

                  </select>

                </div>

                {/* Note Required */}
                <div className="form-row">

                  <label className="form-label">
                    Note required on Next case
                  </label>

                  <input
                    type="checkbox"
                    checked={
                      caseData?.noteRequired ||
                      false
                    }
                    onChange={(e) =>
                      setCaseData((prev) => ({
                        ...prev,
                        noteRequired:
                          e.target.checked
                      }))
                    }
                    className="small-checkbox"
                  />

                </div>

                {/* Copy Practice Note */}
                <div className="form-row">

                  <label className="form-label">
                    Copy practice note to next-case
                  </label>

                  <input
                    type="checkbox"
                    checked={
                      caseData?.copyPracticeNote ||
                      false
                    }
                    onChange={(e) =>
                      setCaseData((prev) => ({
                        ...prev,
                        copyPracticeNote:
                          e.target.checked
                      }))
                    }
                    className="small-checkbox"
                  />

                </div>

                {/* Copy Practice Files */}
                <div className="form-row">

                  <label className="form-label">
                    Copy practice files to next-case
                  </label>

                  <input
                    type="checkbox"
                    checked={
                      caseData?.copyPracticeFiles ||
                      false
                    }
                    onChange={(e) =>
                      setCaseData((prev) => ({
                        ...prev,
                        copyPracticeFiles:
                          e.target.checked
                      }))
                    }
                    className="small-checkbox"
                  />

                </div>

                {/* Remake Note */}
                <div className="form-row">

                  <label className="form-label">
                    Remake note in previous case
                  </label>

                  <div className="remake-note-wrapper">

                    <input
                      type="checkbox"
                      checked={
                        caseData?.remakeNote ||
                        false
                      }
                      onChange={(e) =>
                        setCaseData((prev) => ({
                          ...prev,
                          remakeNote:
                            e.target.checked
                        }))
                      }
                      className="small-checkbox"
                    />

                    <span className="remake-note-text">
                      Create a case note about the
                      remake in the previous case
                    </span>

                  </div>

                </div>

              </div>
            </div>

            {/* DESCRIPTIONS */}
            <div>

              <h4 className="section-title">
                Descriptions
              </h4>

              <div className="box-container">

                <div className="add-button-wrapper">

                  <button
                    type="button"
                    onClick={handleOpenModal}
                    className="add-button"
                  >
                    + Add
                  </button>

                </div>

                <div className="description-table-wrapper">

                  <table className="description-table">

                    <thead>
                      <tr>

                        <th className="description-heading">
                          Description
                        </th>

                        <th className="amount-heading">
                          Amount
                        </th>

                        <th className="action-heading">
                          Action
                        </th>

                      </tr>
                    </thead>

                    <tbody>

                      {descriptions.length === 0 ? (

                        <tr>

                          <td
                            colSpan="3"
                            className="no-data-cell"
                          >
                            No data available in table
                          </td>

                        </tr>

                      ) : (

                        descriptions.map(
                          (desc, index) => (

                            <tr
                              key={index}
                              className="description-row"
                            >

                              <td className="description-cell">
                                {desc.description}
                              </td>

                              <td className="amount-cell">
                                {desc.amount}
                              </td>

                              <td className="action-cell">

                                <button
                                  type="button"
                                  onClick={() =>
                                    handleRemoveDescription(
                                      index
                                    )
                                  }
                                  className="remove-description-button"
                                >
                                  ×
                                </button>

                              </td>

                            </tr>

                          )
                        )

                      )}

                    </tbody>

                  </table>

                </div>
              </div>
            </div>

            {/* BUTTONS */}
            <div className="form-buttons">

              <button
                type="button"
                onClick={handleSave}
                disabled={saving}
                className={`save-button ${
                  saving
                    ? 'button-disabled'
                    : ''
                }`}
              >
                {saving ? 'Saving...' : 'Save'}
              </button>

              <button
                type="button"
                onClick={handleCancel}
                className="cancel-button"
              >
                Cancel
              </button>

            </div>

          </div>
        </div>
      </div>

      {/* MODAL */}
      {showModal && (

        <div className="modal-overlay">

          <div className="description-modal">

            <div className="modal-header">

              <h5 className="modal-title">
                Description
              </h5>

              <button
                type="button"
                onClick={handleCloseModal}
                className="modal-close-button"
              >
                ×
              </button>

            </div>

            <div className="modal-body">

              <div className="modal-form-row">

                <label className="modal-label">
                  Name{' '}
                  <span className="required-star">
                    *
                  </span>
                </label>

                <input
                  type="text"
                  value={newDescription}
                  onChange={(e) =>
                    setNewDescription(
                      e.target.value
                    )
                  }
                  placeholder="Enter description name"
                  className="modal-input"
                />

              </div>

              <div className="modal-form-row">

                <label className="modal-label">
                  Amount (£)
                </label>

                <input
                  type="number"
                  value={newAmount}
                  onChange={(e) =>
                    setNewAmount(
                      e.target.value
                    )
                  }
                  placeholder="0"
                  className="modal-input"
                />

              </div>

            </div>

            <div className="modal-footer">

         

              <button
                type="button"
                onClick={handleAddDescription}
                className="modal-save-button"
              >
                Save
              </button>

            </div>

          </div>

        </div>

      )}

    </>
  );
};

export default Editnextcase;